import { attachmentSendFile } from './attachmentSendFile'

/**
 * Wait for **this composer's** in-flight uploads to settle, then build the File
 * list with each attachment's resolved documentId. Prevents a fast send (e.g.
 * Enter mid-upload) from shipping an attachment with a null id, which would
 * silently drop it from doc_scope.
 */
export async function resolveSendFiles(attachments, uploads) {
  const resolved = (await uploads?.awaitAll()) ?? []
  const docIdById = new Map(resolved.map((entry) => [entry.id, entry.documentId]))
  return attachments.map((attachment) =>
    attachmentSendFile({
      ...attachment,
      documentId: attachment.documentId ?? docIdById.get(attachment.id) ?? null,
    }),
  )
}
